import { Injectable } from '@angular/core';
import { CommonConstants } from '../constants/upplm.constants';

@Injectable()
export class UpplmErrorHandlerService {
    public Errors = [{
        ErrorMessage: ''
    }];
    public errorList = [];
    public errors: any;
    public apiErrorKey: any;
    public LocationStack = []; //need to discuss -- scopestack service
    public errorCodeList: any;

    constructor() {
        /* empty */
    }

    createError(form, errorCode): void {  //-scope parameter alternate -- need to discuss

        let errorInformation = this.Errors[errorCode];
    }

    getErrorList(form, errorsList) {
        let output = [];
        for (let i = 0; i < errorsList.length; i++) {
            output.push(this.Errors[errorsList[i]]);
        }
        return output;
    }

    createErrorList(errorCode) {
        let output = [];

        if (typeof errorCode === 'string') {
            this.errorCodeList = [errorCode];
        }
        else {
            this.errorCodeList = [errorCode.ErrorCode];
        }
        for (let i = 0; i < this.errorCodeList.length; i++) {
            var insertCode = this.errorCodeList[i];
            output.push(this.Errors[insertCode] || this.Errors[CommonConstants.CV_GENERIC_ERROR]);
        }
        return output;
    }
}